import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  calculateSubtotal,
  calculateVAT,
  calculateTotal,
  calculateAmount,
} from '../calculations'
import { InvoiceLine } from '../type'

import style from './style.scss'

type Props = {
  lines: InvoiceLine[]
}

const Total = ({ lines }: Props) => {
  const { t } = useTranslation()

  return (
    <>
      <tr>
        <td colSpan={1} />
        <td className={style.textRight}>{calculateAmount(lines)}</td>
        <td colSpan={3} />
        <td className={style.textRight}>{t('Subtotal')}</td>
        <td className={style.textRight}>{calculateSubtotal(lines)}</td>
        <td />
      </tr>
      <tr>
        <td colSpan={5} />
        <td className={style.textRight}>{t('VAT')}</td>
        <td className={style.textRight}>{calculateVAT(lines)}</td>
        <td />
      </tr>
      <tr>
        <td colSpan={5} />
        <td className={style.textRight}>{t('Total')}</td>
        <td className={style.textRight}>{calculateTotal(lines)}</td>
        <td />
      </tr>
    </>
  )
}

export default Total
